// HeroSection.js
import React from 'react';



const NotFoundPage = () => (
    <div className={"content"}>
        <h1>Oops! Page Not Found</h1>
        <p>Sorry, we can't find the page you were looking for. Kilroy Blockchain can help you with AI and blockchain integration in your business processes.</p>
        <p><a href={"https://kilroyblockchain.com"}>Let's get you started!</a></p>

    </div>
);


export default NotFoundPage;